const hexToRGB = (hex, alpha = 1) => {
  let r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);

  return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
}

const MatchItem = ({ item, styles }) => {
  const { leagueName, arena, time, homeTeamName, homeScoreResult, homeTeamLogo, guestTeamName, guestScoreResult, guestTeamLogo } = item;
  const { date, teams, header, showLeague, showVenue, showLogos } = styles;

  const borderColor = hexToRGB(date.backgroundColor, 0.5);

  const renderText = (text, className = '', maxWidth = '200px') => {
    const displayText = text || '-';
    return (
      <div className={`truncate ${className}`} style={{ maxWidth }} title={displayText}>
        {displayText}
      </div>
    );
  };

  const renderScore = (team, score, compareScore, shouldAddBorder, teamLogo) => (
    <div className={`flex justify-between items-center ${score > compareScore && 'font-bold'}`} style={{ padding: '1rem', borderBottom: shouldAddBorder ? `1px solid ${borderColor}` : 'none', backgroundColor: teams.backgroundColor, color: teams.textColor }}>
      {(showLogos && teamLogo) && <img src={teamLogo} alt={`${team} logo`} style={{ marginRight: '10px', height: '40px', width: '40px', objectFit: 'contain' }} draggable="false" />}
      {renderText(team, 'text-sm', '200px')}
      <div className="flex-shrink-0 flex-grow text-right">{score}</div>
    </div>
  );

  return (
    <div className={`flex flex-col h-fit relative overflow-hidden group`} style={{ borderRight: `1px solid ${borderColor}` }}>
      <div className={`flex justify-between items-center`} style={{ padding: '1rem', backgroundColor: header.backgroundColor, color: header.textColor }}>
        <div className={`flex-auto truncate overflow-hidden`}>
          {showLeague && renderText(leagueName, 'font-bold')}
          {showVenue && renderText(arena, showLeague ? 'text-sm' : 'font-bold')}
        </div>
        <div className="flex-shrink-0 flex-grow text-right">{renderText(time)}</div>
      </div>
      {renderScore(homeTeamName, homeScoreResult, guestScoreResult, true, homeTeamLogo)}
      {renderScore(guestTeamName, guestScoreResult, homeScoreResult, false, guestTeamLogo)}
    </div>
  );
};

export default MatchItem;
